import { useEffect, useState } from "react";

//Util
import { CHAVE_MENSAGEM_MANUTENCAO } from "../utils/manutencao.js";
import { fn_getPathTenantCache } from "../utils/sessao.js";
import { fn_aplicarTema, fn_getTemaTenant } from "../utils/tema.js";

/*
 * Página apresentada quando o bloqueio de manutenção é ligado com o usuário logado (a sessão é encerrada)
 */
function Manutencao() {
  const [mensagem, setMensagem] = useState("");

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    //Retira o espaço reservado para o cabeçalho do sistema, que não aparece nesta página
    document.body.classList.add("login");

    //Aplica o tema do último tenant acessado (a sessão já foi encerrada), para o título ficar na cor do tenant
    fn_aplicarTema(fn_getTemaTenant(fn_getPathTenantCache()));

    setMensagem(sessionStorage.getItem(CHAVE_MENSAGEM_MANUTENCAO) || "");

    return () => {
      document.body.classList.remove("login");
    };
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="text-center">
        <h2 className="titulo-pagina-aviso">Sistema em manutenção</h2>
        <p>
          {mensagem.replace(/^Sistema em manutenção\.\s*/, "") ||
            "Tente acessar novamente mais tarde."}
        </p>
      </div>
    </div>
  );
}

export default Manutencao;
